import { isDefined } from "@utils/var.check";

/**
 * This store is used to keep track on accordion item expand(true)/collapse(false) state
 */

export default {
  state: {
    accordionItemsByComponentId: {},
  },
  initAccordionItemsState(componentId, accordionItems) {
    this.state.accordionItemsByComponentId[componentId] = accordionItems;
  },
  setAccordionItemState(componentId, accordionItemId, accordionState) {
    let accordionItems = this.state.accordionItemsByComponentId[componentId];

    if (!isDefined(accordionItems)) {
      accordionItems = [{ id: accordionItemId, state: accordionState }];
      this.state.accordionItemsByComponentId[componentId] = accordionItems;
      return;
    }

    accordionItems.forEach((accordion) => {
      if (accordion.id === accordionItemId) {
        accordion.state = accordionState;
      }
    });
    this.state.accordionItemsByComponentId[componentId] = accordionItems;
  },
  getAccordionItemState(componentId, accordionItemId) {
    let accordionItems = this.state.accordionItemsByComponentId[componentId];
    if (!isDefined(accordionItems)) {
      accordionItems = [{ id: accordionItemId, state: false }];
      this.state.accordionItemsByComponentId[componentId] = accordionItems;
      return false;
    }
    return accordionItems.find((accordion) => {
      return accordion.id === accordionItemId;
    }).state;
  },
  reset(componentId) {
    delete this.state.accordionItemsByComponentId[componentId];
  },
};
